import {FC, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useParams} from 'react-router-dom'
import {
  fetchActiveIntegrationApp,
  getExternalProviderById,
  resetSelectedIntegrationData,
} from './IntegrationSlice/IntegrationSlice'
import {getUserData} from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {ClickFunnels} from './Providers/ClickFunnels'
import {ProviderCode} from './IntegrationSlice/Types'
import {ClickFunnelsClassic} from './Providers/ClickFunnelsClassic'
import {Zapier} from './Providers/Zapier'
import {Ghl} from './Providers/Ghl'
import {Stripe} from './Providers/Stripe'
import {Pabbly} from './Providers/Pabbly'
import {Make} from './Providers/Make'
import {HubSpot} from './Providers/HubSpot'
import {Wordpress} from './Providers/Wordpress'
import {JobAdder} from './Providers/JobAdder'
import {ActiveCampaign} from './Providers/ActiveCampaign'

const IntegrationPageDetailWrapper: FC = () => {
  const {id} = useParams()
  const userData = useSelector(getUserData)
  const selectedExternalProvider = useSelector(getExternalProviderById(id))

  const dispatch = useDispatch()

  // load data when first load
  useEffect(() => {
    dispatch(resetSelectedIntegrationData)
    dispatch(fetchActiveIntegrationApp())
  }, [])

  return (
    <div>
      {selectedExternalProvider?.code === ProviderCode.CLICK_FUNNELS && (
        <ClickFunnels selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}

      {selectedExternalProvider?.code === ProviderCode.CLICK_FUNNELS_CLASSIC && (
        <ClickFunnelsClassic
          selectedExternalProvider={selectedExternalProvider}
          userData={userData}
        />
      )}

      {selectedExternalProvider?.code === ProviderCode.ZAPIER_CODE && (
        <Zapier selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}

      {selectedExternalProvider?.code === ProviderCode.GO_HIGH_LEVEL && (
        <Ghl selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}

      {selectedExternalProvider?.code === ProviderCode.STRIPE && (
        <Stripe selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}

      {selectedExternalProvider?.code === ProviderCode.PABBLY && (
        <Pabbly selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}

      {selectedExternalProvider?.code === ProviderCode.MAKE && (
        <Make selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}

      {selectedExternalProvider?.code === ProviderCode.JOBADDER && (
        <JobAdder selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}

      {selectedExternalProvider?.code === ProviderCode.HUBSPOT && (
        <HubSpot selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}

      {selectedExternalProvider?.code === ProviderCode.WORDPRESS && (
        <Wordpress selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}

      {selectedExternalProvider?.code === ProviderCode.ACTIVE_CAMPAIGN && (
        <ActiveCampaign selectedExternalProvider={selectedExternalProvider} userData={userData} />
      )}
    </div>
  )
}

export {IntegrationPageDetailWrapper}
